import { useState } from "react";

function readAndStripParam(param: string): string | null {
  const params = new URLSearchParams(window.location.search);
  const value = params.get(param);
  if (!value) return null;

  params.delete(param);
  const search = params.toString();
  const url = `${window.location.pathname}${search ? `?${search}` : ""}${window.location.hash}`;
  window.history.replaceState(null, "", url);
  return value;
}

export function useDeepLinkParam(param: string): string | null {
  const [value] = useState(() => readAndStripParam(param));
  return value;
}
